skrilla.controller('pickemsEntryModalCtrl', function ($scope, searchService, cacheService, srefService, modalService, queryService, paginationService, sportService) {

  $scope.entry = cacheService.getObject("entry");
  $scope.contest =cacheService.getObject("contest");
  const outcomes = {};
  Object.entries($scope.contest.markets).forEach(([k,m])=> {
    Object.assign(outcomes, m.outcomes);
  })
  $scope.outcomes = outcomes;

});
